import { Injectable } from '@angular/core';
import { LMContextService } from '@services/lm-context.service';

@Injectable()
export class LMFormManualRepService {

  private _dataView: LMDataView = null;
  private _formSpec: LMFormSpec = null;
  private _manualRepSpec: any = null; // this needs to be typed once leon does the parsing
  private count = 0;

  constructor(private lmContextService: LMContextService) {}

  public setDataView(dataView: LMDataView): void {
    this._dataView = dataView;
  }
  // public getDataView(): LMDataView {
  //   return this._dataView;
  // }

  public setFormSpec(formSpec: LMFormSpec): void {
    this._formSpec = formSpec;
  }

  public setManualRepSpec(manualRepSpec: any): void {
    this._manualRepSpec = manualRepSpec;
  }

  // public getFormSpec(): LMFormSpec {
  //   return this._formSpec;
  // }

  // this is only for demo/testing of early Field Manual Rep
  public getCount() {
    return this.count++;
  }

  public getManualRefFields() {
    // use spec to find fields to return

    const fields: any = [];
    if (this._dataView && this._manualRepSpec) {
      const dataFields: LMFields = this._dataView.fields;
      let repFields: LMFields;

      for (let index = 0; index <  this._manualRepSpec.fields.length; index++) {
        //    let field: LMField = dataFields[this._manualRepSpec.fields[index]];
        const jsonField = this._dataView.fields[this._manualRepSpec.fields[index]];
        const field =  {name: this._manualRepSpec.fields[index], field: jsonField};
        fields.push(field);
      }
    }

    return fields;
  }


  public getContext(): LMContext {
    return this.lmContextService.getContext();
  }
}
